import React from 'react'

export const ProductProvisioningError = ({ isModal }) => {
    return (
        <div className={isModal ?"provisioning" :"provisioning-page"}>
        <span>{"We are currently working on provisioning you with the product. You will be notified via SMS upon successful activation."}</span>
    </div>
    )
}